import { useParams } from 'react-router-dom'

import { useLlmoAnalysisDetailApi } from '@/common/api/modules/llmo'
import { SentimentHistoryDetailResponse } from '@/common/api/params/llmo'
import { MediaAnalysisType } from '@/common/model/media/mediaAnalysis'

import SentimentResultView from '@/components/container/modules/mediaGeo/sentiment/SentimentResultView'

import MediaAnalysisResultPageBase from './MediaAnalysisResultPageBase'

// センチメント分析結果（GEO/LLMO）
const MediaAnalysisSentimentResultPage = () => {
  const { siteId, historyId } = useParams()
  const sid = Number(siteId)
  // 分析中（status=analyzing）の間は2秒間隔でポーリングし、完了したら自動的に停止する
  const { data, error } = useLlmoAnalysisDetailApi<SentimentHistoryDetailResponse>(
    siteId && historyId ? { site_id: sid, history_id: Number(historyId) } : undefined,
    { refreshInterval: (latest) => (latest?.status === 'analyzing' ? 2000 : 0) }
  )

  return (
    <MediaAnalysisResultPageBase
      type={MediaAnalysisType.SENTIMENT}
      data={data}
      error={error}
      resultError={data?.result?.error}
    >
      {data?.result && (
        <SentimentResultView result={data.result} siteId={sid} historyId={Number(historyId)} />
      )}
    </MediaAnalysisResultPageBase>
  )
}

export default MediaAnalysisSentimentResultPage
